import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export const CREATE_ROLE_PLAY_FEEDBACK_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaCreateRolePlayFeedback($input: CreateRolePlayFeedbackMutationInput!) {
    embaCreateRolePlayFeedback(input: $input) {
      success
    }
  }
`);

export const useCreateRolePlayFeedbackMutation = (
  embaUserRolePlayResultId: string,
) => {
  const [
    createRolePlayFeedbackMutation,
    {
      error: createRolePlayFeedbackMutationError,
      loading: createRolePlayFeedbackMutationLoading,
    },
  ] = useMutation(CREATE_ROLE_PLAY_FEEDBACK_MUTATION);

  const createRolePlayFeedback = useCallback(
    async (rating: number, comment: string): Promise<void> => {
      await createRolePlayFeedbackMutation({
        variables: {
          input: {
            embaUserRolePlayResultId,
            rating,
            comment: comment || null,
          },
        },
      });
    },
    [embaUserRolePlayResultId, createRolePlayFeedbackMutation],
  );

  return {
    createRolePlayFeedback,
    createRolePlayFeedbackMutationError,
    createRolePlayFeedbackMutationLoading,
  };
};
